import React, { useMemo } from "react";
import ContentManagement from "../../ContentManagement/ContentManagement";
import chapterManagementService from "../../../services/ChapterManagementService";
import { useLocation } from "react-router-dom";
import { getEntity } from "../../../common/CommonFunctions";
import { CONTENT_TYPES_CONFIG } from "../../../config/App.config";

const EducationalChapters = () => {
  const location = useLocation();

  const meta = useMemo(() => {
    const stateMeta = location.state || {};
    const sessionMeta = getEntity("CHAPTERS_META") || {};
    return { ...sessionMeta, ...stateMeta };
  }, [location.state]);

  const topicId = meta?.topicId;

  const fetchParams = useMemo(() => ({
    page: 1,
    limit: 12,
    isActive: true,
    status: "published",
    topicId,
  }), [topicId]);

  return (
    <ContentManagement
      service={{
        getAll: (params) => chapterManagementService.getAllByTopic(topicId, params),
      }}
      pageSize={12}
      fetchParams={fetchParams}
      sidebarItemLayout="horizontal"
      getSlug="title"
      contentType={CONTENT_TYPES_CONFIG.CHAPTER}
      onCardClick={() => {}}
      onLearnClick={() => {}}
      onQuizClick={() => {}}
    />
  );
};

export default EducationalChapters;